import Typewriter from 'typewriter-effect/dist/core';

export default function () {
  window.initTypewriter = function (el) {
    let originalText = el.textContent;

    let typewriter = new Typewriter(el, {
      loop: true,
      delay: 75
    });

    // dirty overloading of custom functions here…
    typewriter.pasteOriginalText = function () {
      return this.pasteString(originalText);
    };

    typewriter.alter = function (value) {
      if (!value) {
        return this;
      }
      let values = value.split(',');
      let defaultDuration = 2000;
      let stringLengthOfLastText = 0;
      for (let i = 0; i < values.length; i++) {
        let [text, duration] = values[i].split(':');
        if (!duration) {
          duration = defaultDuration;
        }
        if (stringLengthOfLastText > 0) {
          this.deleteChars(stringLengthOfLastText);
        }
        stringLengthOfLastText = text.length;
        this.typeString(text).pauseFor(duration);
      }
      return this;
    };

    let animation = JSON.parse(el.dataset.typewriterJs);
    if (animation.length === 0) {
      return;
    }
    animation.forEach(step => {
      let { command, value } = step;
      if (/^\d+$/.test(value)) {
        // convert to number
        value = Number(value);
      }
      typewriter[command](value);
    });
    typewriter.start();
  };

  document.querySelectorAll('*[data-typewriter-js]').forEach(el => {
    window.initTypewriter(el);
  });
}
